import React, { useState } from 'react';
import MultiLineChart from '../graphs/MultiLineChart';
import { usePortfolioDateFormatter } from '../../utils/usePortfolioDateFormatter';

// Visual configuration for the per-sector transformer chart.
// Domain matches real GENERATED_MW values (0–~185 MW across all 4 sectors).
const TRANSFORMER_CHART_CONFIG = {
  duration: '48hr',
  color: '#D07F15',
  domain: [0, 200],
  tickValues: [200, 100, 0],
  unit: 'MW',
  tooltipUnit: 'MWh',
  midlines: [{ value: 100, label: '100 MW' }],
  wrapperClassName: 'transformer',
  height: 170,
};

function formatChartStat(value, unit) {
  if (value == null || !Number.isFinite(value)) {
    return '—';
  }
  const formatted = value.toLocaleString('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
  return `${formatted} ${unit}`;
}

function SectorTransformerChart({ sector, portfolioName, onTooltip, timeZone }) {
  const [plotted, setPlotted] = useState(null);

  return (
    <MultiLineChart
      {...TRANSFORMER_CHART_CONFIG}
      key={`sector-${sector.id}-48hr`}
      dataEndpoint={`/api/graph/portfolio/${portfolioName}/sector/${sector.id}/metrics/48hr`}
      onTooltip={onTooltip}
      timeZone={timeZone}
      onPlottedTotal={setPlotted}
      headerLeft={(
        <>
          <strong>GENERATED ENERGY TODAY </strong> &nbsp;
          <span className="generated-energy-total">({formatChartStat(plotted?.total, 'MWh')})</span>
        </>
      )}
      headerRight={(
        <>
          <strong>GRID PEAK </strong> &nbsp;
          <span className="generated-energy-total">({formatChartStat(plotted?.max, 'MW')})</span>
        </>
      )}
    />
  );
}

const TransformerTabs = ({ activeXFMR, setActiveXFMR, sectors, portfolioName, onTooltip }) => {
  const dateFormatter = usePortfolioDateFormatter({ portfolioName });
  return (
    <div className="transformers col-8 d-flex flex-column justify-content-between gap-3">
      {sectors.map((sector, index) => (
        <div key={sector.id ?? index} className={`${activeXFMR === index ? 'current' : ''}`}>
          <button onClick={() => setActiveXFMR(index)}>
            {sector.sector_name}
          </button>
          {/* All four sector charts are visible at once, so each needs its own data.
              Backend responses are TTL-cached per sector, capping Snowflake wakeups. */}
          <SectorTransformerChart
            sector={sector}
            portfolioName={portfolioName}
            onTooltip={onTooltip}
            timeZone={dateFormatter.timeZone}
          />
        </div>
      ))}
    </div>
  );
};

export default TransformerTabs;
